import styled from 'styled-components';

const UploadImageModal = styled.div`
  width: 100%;

  .branding-button {
    align-items: center;
    background: transparent;
    border: none;
    cursor: pointer;
    display: flex;
    font-size: 18px;
    text-decoration: underline;
    transition: 0.25s;

    &:hover {
      color: var(--color-accent-secondary-default);
    }

    svg {
      margin-left: 16px;
    }
  }
`;

export { UploadImageModal };
